import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

import { EntityTypes } from 'Portals/Internal/constants'

export enum IssueSearchFields {
	searchResultByIssueId = 'searchResultByIssueId',
	searchResultByEntityId = 'searchResultByEntityId',
	searchResultByServiceSiteId = 'searchResultByServiceSiteId',
	searchResultByServiceSiteName = 'searchResultByServiceSiteName'
}

export enum IssueFilterFields {
	dateFrom = 'dateFrom',
	dateTo = 'dateTo',
	issueType = 'issueType',
	entityType = 'entityType',
	assignedTo = 'assignedTo'
}

export enum ResolutionFlags {
	N = 'N',
	D = 'D',
	Y = 'Y'
}

export enum WorkflowActionFlags {
	N = 'N',
	D = 'D',
	R = 'R',
	A = 'A'
}

export enum ActionFormType {
	exception = 'exception',
	comment = 'comment',
	reassign = 'reassign'
}

export declare namespace Issue {
	interface Basic {
		id: number
		description: BasicString
		issueType: BasicString
		entity: Entity | null
		entityType: Entity | null
		assignedTo: BasicString
		createDate: BasicString
		serviceSite: Entity | null
		company: Entity | null
		resolutionFlag: BasicString
		comment: BasicString
	}

	interface IssueItem {
		id: number
		entityId: number
		issueType: BasicString
		solution: BasicString
		description: BasicString
		createdUser: Entity | null
		updatedUser: Entity | null
		assignedUser: Entity | null
		entityType: BasicString
		createDate: BasicString
		updatedDate: BasicString
		ruleId: BasicNumber
		resolutionFlag: ResolutionFlags
		workFlowActionFlag: BasicString
		comment: BasicString
		solutionDescription: BasicString
	}
	namespace Form {
		interface Edit {
			assignedToId: BasicNumber
			workflowFlag: BasicString
			workflowActionComment: string
		}
	}
	namespace Request {
		interface Edit {
			issueId: BasicNumber
			assignedToId: BasicNumber
			updatedBy: BasicString
			workflowFlag: BasicString
			workflowActionComment: BasicString
		}
	}

	namespace Comment {
		interface Basic {
			id: number
			entityId: BasicNumber
			entityType: Entity
			author: BasicString
			commentText: BasicString
			createDate: BasicString
			updatedDate: BasicString
		}
		namespace Form {
			interface Add {
				commentText: string
			}
		}
		namespace Request {
			interface Add {
				entityId: BasicNumber
				entityType: EntityTypes | null
				commentText: BasicString
			}
		}
	}

	namespace Exception {
		interface Basic {
			id: number
			exceptionType: Entity
			exception: Entity
			author: string
			comment: string
			resolutionFlag: ResolutionFlags
			createDate: BasicString
			updatedDate: BasicString
		}
		namespace Form {
			interface Add {
				comment: string
				exceptionTypeId: BasicNumber
				exceptionId: BasicNumber
			}
		}
		namespace Request {
			interface Add {
				entityId: BasicNumber
				entityType: EntityTypes | null
				comment: BasicString
				exceptionId: BasicNumber
				userId: BasicString
			}
		}
	}

	namespace Reassign {
		namespace Form {
			interface Reassign {
				reason: string
				assignee: LabelValue<number> | null
			}
		}
		namespace Request {
			interface Reassign {
				reason: BasicString
				assigneeId: BasicNumber
			}
		}
	}

	namespace Search {
		interface Result {
			[IssueSearchFields.searchResultByIssueId]: Entity[]
			[IssueSearchFields.searchResultByEntityId]: number[]
			[IssueSearchFields.searchResultByServiceSiteId]: Entity[]
			[IssueSearchFields.searchResultByServiceSiteName]: Entity[]
		}

		interface Config {
			[IssueSearchFields.searchResultByIssueId]: ConfigItem<IssueSearchFields>
			[IssueSearchFields.searchResultByEntityId]: ConfigItem<IssueSearchFields>
			[IssueSearchFields.searchResultByServiceSiteId]: ConfigItem<IssueSearchFields>
			[IssueSearchFields.searchResultByServiceSiteName]: ConfigItem<IssueSearchFields>
		}
	}

	namespace Filter {
		interface Config {
			[IssueFilterFields.dateFrom]: ConfigFilterItem<string, null>
			[IssueFilterFields.dateTo]: ConfigFilterItem<string, null>
			[IssueFilterFields.assignedTo]: ConfigFilterItem<string, string>
			[IssueFilterFields.issueType]: ConfigFilterItem<string, string>
			[IssueFilterFields.entityType]: ConfigFilterItem<string, string>
		}
	}
}
